import update from 'immutability-helper'
import { INITIAL_GET_RESULTS_REDUCER, INITIAL_LOADING_REDUCER } from '../../constants/reducer'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_DV360_NEGATIVE_KEYWORD_LISTS,
  GET_DV360_NEGATIVE_KEYWORD_LISTS_SUCCESS,
  GET_DV360_NEGATIVE_KEYWORD_LISTS_FAILURE,
  CLEAR_GET_DV360_NEGATIVE_KEYWORD_LISTS,
  GET_DV360_CHANNELS,
  GET_DV360_CHANNELS_SUCCESS,
  GET_DV360_CHANNELS_FAILURE,
  CLEAR_GET_DV360_CHANNELS,
  GET_DV360_VIEWABILITY_TARGETING_OPTIONS,
  GET_DV360_VIEWABILITY_TARGETING_OPTIONS_SUCCESS,
  GET_DV360_VIEWABILITY_TARGETING_OPTIONS_FAILURE,
  CLEAR_GET_DV360_VIEWABILITY_TARGETING_OPTIONS,
  GET_DV360_EXCHANGE_TARGETING_OPTIONS,
  GET_DV360_EXCHANGE_TARGETING_OPTIONS_SUCCESS,
  GET_DV360_EXCHANGE_TARGETING_OPTIONS_FAILURE,
  CLEAR_GET_DV360_EXCHANGE_TARGETING_OPTIONS,
  GET_DV360_TARGETING_OPTIONS,
  GET_DV360_TARGETING_OPTIONS_SUCCESS,
  GET_DV360_TARGETING_OPTIONS_FAILURE,
  CLEAR_GET_DV360_TARGETING_OPTIONS,
  GET_DV360_TARGETING,
  GET_DV360_TARGETING_FAILURE,
  GET_DV360_TARGETING_SUCCESS,
  CLEAR_DV360_TARGETING,
  CLEAR_SEARCH_DV360_TARGETING_OPTIONS,
  SEARCH_DV360_TARGETING_OPTIONS,
  SEARCH_DV360_TARGETING_OPTIONS_FAILURE,
  SEARCH_DV360_TARGETING_OPTIONS_SUCCESS,
  UPDATE_DV360_BULK_TARGETING,
  UPDATE_DV360_BULK_TARGETING_SUCCESS,
  UPDATE_DV360_BULK_TARGETING_FAILURE,
  CLEAR_UPDATE_DV360_BULK_TARGETING
} from '../actions/dv360Constants'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  dv360ViewabilityTargetingOptions: INITIAL_GET_RESULTS_REDUCER,
  updateDv360BulkTargeting: {
    ...INITIAL_LOADING_REDUCER,
    wasUpdated: false,
    data: []
  },
  dv360Targeting: INITIAL_GET_RESULTS_REDUCER,
  searchDv360TargetingOptions: INITIAL_GET_RESULTS_REDUCER,
  dv360TargetingOptions: INITIAL_GET_RESULTS_REDUCER,
  dv360ExchangeTargetingOptions: INITIAL_GET_RESULTS_REDUCER,
  dv360Channels: INITIAL_GET_RESULTS_REDUCER,
  dv360NegativeKeywordLists: INITIAL_GET_RESULTS_REDUCER
}

export default function dv360Constants(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS

    // Get targeting
    case GET_DV360_TARGETING:
      return update(state, {
        dv360Targeting: { $merge: { isLoading: true } }
      })
    case GET_DV360_TARGETING_SUCCESS:
      return update(state, {
        dv360Targeting: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_DV360_TARGETING_FAILURE:
      return update(state, {
        dv360Targeting: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_DV360_TARGETING:
      return update(state, {
        dv360Targeting: { $set: initialState.dv360Targeting }
      })
    // Search targeting options
    case SEARCH_DV360_TARGETING_OPTIONS:
      return update(state, {
        searchDv360TargetingOptions: { $merge: { isLoading: true } }
      })
    case SEARCH_DV360_TARGETING_OPTIONS_SUCCESS:
      return update(state, {
        searchDv360TargetingOptions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case SEARCH_DV360_TARGETING_OPTIONS_FAILURE:
      return update(state, {
        searchDv360TargetingOptions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_SEARCH_DV360_TARGETING_OPTIONS:
      return update(state, {
        searchDv360TargetingOptions: { $set: initialState.searchDv360TargetingOptions }
      })

    // Update dv360 bulk targeting
    case UPDATE_DV360_BULK_TARGETING:
      return update(state, {
        updateDv360BulkTargeting: { $merge: { isLoading: true } }
      })
    case UPDATE_DV360_BULK_TARGETING_SUCCESS:
      return update(state, {
        updateDv360BulkTargeting: {
          $merge: {
            isLoading: false,
            wasUpdated: true,
            data: action.data
          }
        }
      })
    case UPDATE_DV360_BULK_TARGETING_FAILURE:
      return update(state, {
        updateDv360BulkTargeting: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_UPDATE_DV360_BULK_TARGETING:
      return update(state, {
        updateDv360BulkTargeting: { $set: initialState.updateDv360BulkTargeting }
      })

    // Get dv360 targeting options
    case GET_DV360_TARGETING_OPTIONS:
      return update(state, {
        dv360TargetingOptions: { $merge: { isLoading: true } }
      })
    case GET_DV360_TARGETING_OPTIONS_SUCCESS:
      return update(state, {
        dv360TargetingOptions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_DV360_TARGETING_OPTIONS_FAILURE:
      return update(state, {
        dv360TargetingOptions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_DV360_TARGETING_OPTIONS:
      return update(state, {
        dv360TargetingOptions: { $set: initialState.dv360TargetingOptions }
      })

    // Get dv360 exchange targeting options
    case GET_DV360_EXCHANGE_TARGETING_OPTIONS:
      return update(state, {
        dv360ExchangeTargetingOptions: { $merge: { isLoading: true } }
      })
    case GET_DV360_EXCHANGE_TARGETING_OPTIONS_SUCCESS:
      return update(state, {
        dv360ExchangeTargetingOptions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_DV360_EXCHANGE_TARGETING_OPTIONS_FAILURE:
      return update(state, {
        dv360ExchangeTargetingOptions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_DV360_EXCHANGE_TARGETING_OPTIONS:
      return update(state, {
        dv360ExchangeTargetingOptions: { $set: initialState.dv360ExchangeTargetingOptions }
      })

    // Get dv360 viewability targeting options
    case GET_DV360_VIEWABILITY_TARGETING_OPTIONS:
      return update(state, {
        dv360ViewabilityTargetingOptions: { $merge: { isLoading: true } }
      })
    case GET_DV360_VIEWABILITY_TARGETING_OPTIONS_SUCCESS:
      return update(state, {
        dv360ViewabilityTargetingOptions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_DV360_VIEWABILITY_TARGETING_OPTIONS_FAILURE:
      return update(state, {
        dv360ViewabilityTargetingOptions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_DV360_VIEWABILITY_TARGETING_OPTIONS:
      return update(state, {
        dv360ViewabilityTargetingOptions: { $set: initialState.dv360ViewabilityTargetingOptions }
      })

    // Get dv360 channels
    case GET_DV360_CHANNELS:
      return update(state, {
        dv360Channels: { $merge: { isLoading: true } }
      })
    case GET_DV360_CHANNELS_SUCCESS:
      return update(state, {
        dv360Channels: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_DV360_CHANNELS_FAILURE:
      return update(state, {
        dv360Channels: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_DV360_CHANNELS:
      return update(state, {
        dv360Channels: { $set: initialState.dv360Channels }
      })

    // Get dv360 negative keyword lists
    case GET_DV360_NEGATIVE_KEYWORD_LISTS:
      return update(state, {
        dv360NegativeKeywordLists: { $merge: { isLoading: true } }
      })
    case GET_DV360_NEGATIVE_KEYWORD_LISTS_SUCCESS:
      return update(state, {
        dv360NegativeKeywordLists: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_DV360_NEGATIVE_KEYWORD_LISTS_FAILURE:
      return update(state, {
        dv360NegativeKeywordLists: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_DV360_NEGATIVE_KEYWORD_LISTS:
      return update(state, {
        dv360NegativeKeywordLists: { $set: initialState.dv360NegativeKeywordLists }
      })

    default:
      return state
  }
}
